import {
    SET_BRANCHES,
    RESET_BRANCHES,
  } from "../constants/branches"
  import {
    propOr
  } from "ramda"
  import axios from "@/utils/axios"
  
  const initialState = () => ({
    branches: {
    },
    // currentTeacher: {}
  })
  
  const state = initialState()
  
  const getters = {
    paginateBranches: propOr({}, 'branches'),
    // currentTeacher: propOr({}, 'currentTeacher')
  }
  
  const actions = {
    getBranches({ commit, rootGetters }, { page = 1, search = null } = {}) {
      const organizationId = rootGetters['organization/currentOrganizationId'];
      const params = {
        page,
        search
    };
      return axios.get(`v1/organizations/${organizationId}/all-branches`, { params })
        .then(response => commit(SET_BRANCHES, response.data))
    },
    reset({ commit }) {
      return commit(RESET_BRANCHES)
    },
    // getTeacher({ dispatch }, { teacherId, organizationId }){
    //   return axios.get(`v1/organizations/${organizationId}/users/${teacherId}`)
    //     .then(response => dispatch('setCurrentTeacher', response.data))
    // },
    // setCurrentTeacher({ commit }, teacher) {
    //   return commit(CURRENT_TEACHER, teacher)
    // }
  }
  
  const mutations = {
    [SET_BRANCHES](state, paginateBranches) {
      state.branches = { ...paginateBranches }
    },
    [RESET_BRANCHES](state) {
      Object.assign(state, initialState())
    },
    // [CURRENT_TEACHER](state, teacher) {
    //   state.currentTeacher = teacher
    // }
  }
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
  }
  